<template>
  <div>
    <b-sidebar
      id="add-kernet-sidebar"
      sidebar-class="sidebar-lg"
      bg-variant="white"
      :visible="addKernetSidebar"
      right
      no-header
      backdrop
      @hidden="(val) => changeValue(val)"
    >
      <template #default="{ hide }">
        <!-- Header -->
        <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
          <h5
            class="mb-0"
          >
            {{ kernetLocal.id > 0 ? 'Edit Kernet' : 'Add Kernet' }}
          </h5>
          <feather-icon
            class="ml-1 cursor-pointer"
            icon="XIcon"
            size="16"
            @click="hide"
          />
        </div>

        <!-- Body -->
        <validation-observer
          ref="simpleRules"
          class="px-2"
        >
          <b-form>
            <b-row class="px-2">
              <b-col md="12">
                <b-form-group
                  label="Nama"
                  label-for="kernet-name"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="Kernet Name"
                    rules="required"
                  >
                    <b-form-input
                      id="kernet-name"
                      v-model="kernetLocal.nama"
                      :state="errors.length > 0 ? false:null"
                      placeholder="Nama Kernet"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="12">
                <b-form-group
                  label="Email"
                  label-for="supir-email"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="Email"
                    rules="required|email"
                  >
                    <b-form-input
                      id="supir-email"
                      v-model="kernetLocal.email"
                      :state="errors.length > 0 ? false:null"
                      placeholder="Email"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col
                v-show="kernetLocal.id < 1"
                md="12"
              >
                <b-form-group
                  label="Password"
                  label-for="supir-password"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="Password"
                    rules="required"
                  >
                    <b-form-input
                      id="supir-password"
                      v-model="kernetLocal.password"
                      type="password"
                      :state="errors.length > 0 ? false:null"
                      placeholder="Password"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="12">
                <b-form-group
                  label="No Telepon"
                  label-for="kernet-no-telepon"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="No Telepon"
                    rules="required"
                  >
                    <b-form-input
                      id="kernet-no-telepon"
                      v-model="kernetLocal.no_telp"
                      :state="errors.length > 0 ? false:null"
                      placeholder="No Telepon"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="12">
                <b-form-group
                  label="Status"
                  label-for="status-status"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="Status"
                    rules="required"
                  >
                    <b-form-select
                      id="status-status"
                      v-model="kernetLocal.status"
                      :options="options"
                      :state="errors.length > 0 ? false:null"
                      placeholder="Status"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col
                v-if="kernetLocal.id > 0 && kernetLocal.foto"
                md="12"
              >
                <b-row>
                  <b-col md="12">
                    <label for="preview-image">Preview Foto Sebelumnya: </label>
                  </b-col>
                  <b-col md="12">
                    <b-img
                      id="preview-image"
                      class="mb-2"
                      width="200"
                      :src="kernetLocal.foto"
                      fluid
                      alt="Preview Image"
                    />
                  </b-col>
                </b-row>
              </b-col>
              <b-col md="12">
                <b-form-group
                  label="Foto Kernet"
                  label-for="foto-kernet"
                >
                  <b-form-file
                    id="foto-kernet"
                    v-model="kernetLocal.foto_kernet"
                    accept="image/*"
                    placeholder="Pilih File"
                  />
                </b-form-group>
              </b-col>
              <b-col md="12">
                <b-button
                  variant="primary"
                  class="mr-1"
                  @click="submit()"
                >
                  Submit
                </b-button>
                <b-button
                  variant="outline-secondary"
                  @click="changeValue(false)"
                >
                  Cancel
                </b-button>
              </b-col>
            </b-row>
          </b-form>
        </validation-observer>
      </template>
    </b-sidebar>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BFormInput, BFormGroup, BForm, BButton, BCol,
  BRow, BSidebar, BFormSelect, BFormFile, BImg,
} from 'bootstrap-vue'
import { required, email } from '@validations'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    BFormInput,
    BFormGroup,
    BForm,
    BButton,
    BCol,
    BRow,
    BSidebar,
    BFormSelect,
    BFormFile,
    BImg,
  },
  model: {
    prop: 'addKernetSidebar',
  },
  props: {
    addKernetSidebar: {
      type: Boolean,
      required: true,
    },
    kernet: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      required,
      email,
      kernetLocal: {
        id: null,
        nama: null,
        no_telp: null,
        status: null,
        email: null,
        password: null,
      },
      options: [
        { value: 'tidak_aktif', text: 'Tidak Aktif' },
        { value: 'aktif', text: 'Aktif' },
      ],
    }
  },
  watch: {
    kernet() {
      this.resetTaskLocal()
    },
  },
  methods: {
    resetTaskLocal() {
      this.kernetLocal = {
        id: this.kernet.id,
        nama: this.kernet.nama,
        no_telp: this.kernet.telp,
        status: this.kernet.status,
        foto: this.kernet.foto,
        email: this.kernet.email,
        password: this.kernet.password,
      }
    },
    changeValue() {
      const data = {
        id: null,
        nama: '',
        no_telp: '',
        email: '',
        password: '',
        status: 0,
      }
      this.$emit('kernet-sidebar-change', data, false)
    },
    submit() {
      if (this.kernetLocal.id > 0) {
        this.$emit('submit-data-kernet', this.kernetLocal)
      } else {
        this.$refs.simpleRules.validate().then(success => {
          if (success) {
            this.$emit('submit-data-kernet', this.kernetLocal)
          }
        })
      }
    },
  },
}
</script>
<style>
.b-sidebar-body {
  overflow: hidden !important;
}
</style>
